module.exports = __webpack_public_path__ + "img/monitor.0f1222c0.svg";